import React, { useEffect, useState } from "react";
import "../styles/header.css"
import { Link } from "react-router-dom";
import { getAllDepartment } from "../Services/AllAPIs";

const Header = () => {

    const [loader, setLoader] = useState(true);
    const [departments, setDepartments] = useState([]);
    const [error, setError] = useState(null);
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [noResults, setNoResults] = useState(false);

    const pages = {
        "Academic Calendar": "/academic-calendar",
        "Active Tenders": "/tenders",
        "Biochemistry": "/prog-offered-courses/biochemistry",
        "Shanti Devi Government College": "https://gccjr.org/",
        "Mobile App": "/mobile-app",
        "Departments": "/departments",
        "Department of Biotechnology": "/faculty/Science/department/Biotechnology",
        "Department of Botany": "/faculty/Science/department/Botany",
        "Department of Charak School of Pharmacy": "https://www.csopccsu.com/",
        "Department of Chemistry": "/faculty/Science/department/Chemistry",
        "Department of Commerce": "/faculty/Commerce_and_Management/department/Commerce",
        "Department of Computer Application": "https://scriet.ccsuniversity.ac.in/Department-MCA.php",
        "Department of Economics": "/faculty/Art/department/Economics",
        "Department of Education": "/faculty/Education/department/Education",
        "Department of English": "/faculty/Art/department/English",
        "Department of Fine Arts": "/faculty/Art/department/Fine_Arts",
        "Department of Food Science & Technology": "/faculty/Agriculture/department/Food_Science_and_Technology",
        "Department of Foreign Language": "/faculty/Art/department/Foreign_Language",
        "Department of Genetics & Plant Breeding": "/faculty/Agriculture/department/Genetics_and_Plant_Breeding",
        "Department of Geography": "/faculty/Art/department/Geography",
        "Department of Hindi": "/faculty/Art/department/Hindi",
        "Department of History": "/faculty/Art/department/History",
        "Department of Home Science": "/faculty/Art/department/Home_Science",
        "Department of Horticulture": "/faculty/Agriculture/department/Horticulture",
        "Department of Institute of Business Studies": "/faculty/Commerce_and_Management/department/Institute_of_Business_Studies",
        "Department of Institute of Engineering & Technology": "https://scriet.ccsuniversity.ac.in/",
        "Department of Jewellery Design": "https://ccs.nijtm.com/",
        "Department of Legal Studies": "/faculty/Law/department/Legal_Studies",
        "Department of Library and Information Science": "/faculty/Art/department/Library_and_Information_Science",
        "Department of Mathematics": "/faculty/Science/department/Mathematics",
        "Department of Microbiology": "/faculty/Science/department/Microbiology",
        "Department of Physical Education": "/faculty/Education/department/Physical_Education",
        "Department of Physics": "/faculty/Science/department/Physics",
        "Department of Plant Protection": "/faculty/Agriculture/department/Plant_Protection",
        "Department of Political Science": "/faculty/Art/department/Political_Science",
        "Department of Psychology": "/faculty/Art/department/Psychology",
        "Department of Sanskrit": "/faculty/Art/department/Sanskrit",
        "Department of Seed Science & Technology": "/faculty/Agriculture/department/Seed_Science_and_Technology",
        "Department of Sociology": "/faculty/Art/department/Sociology",
        "Department of Statistics": "/faculty/Science/department/Statistics",
        "Department of Tilak School of Journalism and Mass Communication": "http://www.ccsutsmc.in/index.php",
        "Department of Toxicology": "/faculty/Science/department/Toxicology",
        "Department of Urdu": "/faculty/Art/department/Urdu",
        "Department of Yoga Science": "/faculty/Art/department/Yoga_Science",
        "Department of Zoology": "/faculty/Science/department/Zoology",
        "Faculty Type": "/faculty",
        "Faculty of Agriculture": "/faculty/Agriculture",
        "Faculty Of Arts": "/faculty/Art",
        "Faculty Of Commerce & Management": "/faculty/Commerce_and_Management",
        "Faculty Of Education": "/faculty/Education",
        "Faculty Of Engineering & Technology": "/faculty/Engineering_and_Technology",
        "Faculty Of Law": "/faculty/Law",
        "Faculty Of Pharmacy": "/faculty/Pharmacy",
        "Faculty Of Science": "/faculty/Science",
        "About Us": "/history",
        "Abstract 2021": "/abstract-2021",
        "ACT Mission Shakti 2021": "/act-mission-shakti-2021",
        "Activities": "/activities",
        "Administration": "/administration",
        "Admission Brochure 2023": "/admission-brochure",
        "Admission": "/admission",
        "Anti-Ragging": "/anti-ragging",
        "Campus Syllabus": "/campus-syllabus",
        "Career": "/career",
        "Proceedings": "/proceedings",
        "CCSU Courses": "prog-offered-courses",
        "Cell and Coordinators": "/cell-and-coordinators",
        "Chancellor": "/chancellor",
        "Charan Singh Ji": "/chaudhary-charan-singh",
        "College Syllabus": "/college-syllabus",
        "Colleges": "/colleges",
        "Conduct Discipline": "/conduct-discipline",
        "Contact": "/contact",
        "Deans Faculty": "/deans-faculty",
        "Deans Students Welfare": "/deans-students-welfare",
        "Department of Sports": "/dept-sports",
        "Dispensary": "/dispensary",
        "Distinctiveness": "/distinctiveness",
        "Downloads": "/downloads",
        "Engineering Section": "/engineering-section",
        "Enquiry Numbers": "/enquiry-numbers",
        "Exam Form": "/exam-form-and-admit-card",
        "Exam Related Info": "/exam-related-info",
        "Exam Rules": "/exam-rules",
        "Exam Schedule": "/exam-schedule",
        "Extra-Curricular": "/extra-curricular",
        "Facilities": "/facilities",
        "Faculty Details": "/faculty-details",
        "Faculty Types": "/faculty-types",
        "Faculty": "/faculty",
        "Gallery": "/gallery",
        "Governance": "/governance",
        "Important Email": "/imp-email",
        "home": "/",
        "Industry Consultancy Cell": "/industry-consultancy-cell",
        "Infrastructure": "/infra",
        "IQAC Activities": "/iqac-activities",
        "IQAC AQAR Report": "/iqac-aqar-report",
        "IQAC Contact": "/iqac-contact",
        "IQAC Feedback": "/iqac-feedback",
        "IQAC Letter": "/iqac-letter",
        "IQAC Meet": "/iqac-meet",
        "IQAC Notifications": "/iqac-notifications",
        "IQAC Practices": "/iqac-practices",
        "IQAC": "/iqac",
        "IT Policy": "/it-policy",
        "Library": "/library",
        "List of Holidays": "/holidays-list",
        "Media": "/media-report",
        "NIRF": "/nirf",
        "Officer Incharge": "/officer-incharge",
        "OMR": "/omr",
        "Online Payment": "/online-payment",
        "PhD DLIT": "/phd-dlit",
        "Proceeding AC BOS": "/Proceeding-AC-BOS",
        "Proctors": "/proctors",
        "Program Offered Courses": "/prog-offered-courses",
        "Program Offered": "/prog-offered",
        "Reg Course": "/regular-courses",
        "Research": "/research",
        "RTI": "/rti",
        "Screen Reader": "/screen-reader",
        "Search News": "/search-news",
        "Self Course": "/self-finance-courses",
        "Sports": "/sports-calendar",
        "Student Council": "/student-council",
        "Student Projects Reports": "/Student-Projects-Reports",
        "Student Welfare": "/student-welfare",
        "Syllabus NEP 2020": "/nep-syllabus",
        "Syllabus Skill Dev NEP 2020": "/skill-development-syllabus",
        "Syllabus": "/syllabus",
        "Tenders": "/tenders",
        "University News Letter": "/university-news-letter",
        "Verification": "/verification",
        "Vice Chancellor": "/vice-chancellor",
        "Vision Mission": "/vision-mission",
        "Wardens": "/wardens",
        "Women Cell": "/women-cell",
        "SCREIT (ENGINEERING COLLEGE)": "https://scriet.ccsuniversity.ac.in",
        "Result": "https://result.ccsuniversity.ac.in/",
        "Jewellery Desin Course": "https://ccs.nijtm.com/",
        "Student Help Desk": "https://ccsuwebonline.in/",
        "Hostel Registration": "http://ccsuniversityhostel.com/",
        "Online Fee Payment Of Online Courses": "https://exams.ccsuforms.in/FeePayPanel/",
        "Campus Fee Payment": "https://forms.ccsuforms.in/Campus_Fee/",
        "Online Provisional & Migration Certification": "https://forms.ccsuforms.in/onlinecertificate/",
        "Viva Fees": "https://exams.ccsuforms.in/FeePayPanel/misslenious_fee.php",
        "Student Feedback Form": "https://docs.google.com/forms/d/e/1FAIpQLScYaQi-uCHCKYghmRzDjUR3w7yYs726MGAUShzakyPD0I535g/viewform",
        "Answer Book Viewing": "https://ccsuanswerview.com/",
        "Institutional Repository": "http://ir.ccsuniversity.ac.in/jspui/",
        "Digital Library": "http://digital-lib.ccsuniversity.ac.in/",
        "Bridge Library": "https://bridge-library.ccsuniversity.ac.in/",
        "CCSU E-mail": "https://mail.google.com/",
        // "Nirf":"https://forms.ccsuforms.in/CCS_NIRF/",
        "Campus Admission Portal 2023": "https://ccsuadmission.aimserp.co.in/campus",
        "Registration/ Application form for admission through entrance test in university campus & affiliated colleges 2023-24 (M.ED, B.PED, M.PED, and LLM)": "https://exams.ccsuforms.in/EntranceTest2324/",
        "Registration Form for certificate course in 'Art of Parenting' and 'Inculcating Happiness and Well-Being' 2023-24": "https://exams.ccsuforms.in/CertificateCourse_Reg/",
        "Registration Form for Vedic Mathematics Diploma 2023-24": "https://exams.ccsuforms.in/RegistrationForm/",
        "Registration Form for B.TECH., M.C.A., M.B.A. AND M.TECH. 2023-24": "https://www.ccsuforms.in/",
        "Application Form for Admission in M.ED. course in minority colleges/ Institition : 2023-24": "https://exams.ccsuforms.in/MinorityReg/",
        "Examination Form For Even Semester PG NEP Programs Main/Back/EX 2024": "https://ccsu.aimserp.co.in/web/portal",
        "Admit Card For LLM 1st Sem Main/Back/Ex.": "https://ccsu.aimserp.co.in/web/registration/admit-card?p_p_id=admintcardgenerationpublic_WAR_aimsstudentviewportlet&p_p_lifecycle=0",
        "Admit card for MBBS": "https://exams.ccsuforms.in/mbbs/admitlogin.php",
        "Admit Card for B.Sc. / M.Sc. Nursing": "https://exams.ccsuforms.in/mscbscnur/admitlogin.php",
        "Download Admit Card Yearly Professional Back Paper Exam-2023": "https://ccsu.aimserp.co.in/web/registration/admit-card",
        "ODD Semester Examination (Dec.-2023)- Traditional, Professional & NEP Exam Session 2023-24.": "https://ccsu.aimserp.co.in/web/registration/admit-card",
        "Admit Card For Yearly & Private Back Paper Exam-2023": "https://ccsu.aimserp.co.in/web/registration/admit-card",
        "Alumni": "https://forms.ccsuforms.in/Alumni/index.php",
        "NEP": "https://education-policy.ccsuniversity.ac.in/ccsuniversity.ac.in/ccsu/education-policy.html",
        "CCTV Control Room Daily Report": "https://ccsums.ccsuniversity.ac.in/"
        // Add more pages as needed
    };

    const getDepartments = () => {
        getAllDepartment()
            .then((res) => {
                // console.log("Department details:", res.data.departments);
                setDepartments(res.data.departments);
                setLoader(false);
            })
            .catch((error) => {
                // console.log("Error fetching departments:", error);
                setError("An error occurred while fetching department data.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getDepartments();
    }, []);

    // Handle input change
    const handleInputChange = (event) => {
        const query = event.target.value.trim().toLowerCase();
        setQuery(query);

        if (query.length > 0) {
            const filteredResults = Object.keys(pages).filter((title) =>
                title.toLowerCase().includes(query)
            );

            setResults(filteredResults);

            setNoResults(filteredResults.length === 0);
        } else {
            setResults([]);
            setNoResults(false);
        }
    };
    return (
        <>
            <section id="main-nav">
                <div
                    className="logo d-flex"
                    style={{ justifyContent: "center", alignItems: "center" }}
                >
                    <div className="nav-img">
                        <Link to={"/"}>
                            <img src="/assets/images/CCSU-Logo.jpg" alt="" />
                        </Link>
                        <p>NAAC A++</p>
                    </div>
                    <div className="nav-content">
                        <h1>चौधरी चरण सिंह विश्वविद्यालय, मेरठ</h1>
                        <h4>Chaudhary Charan Singh University, Meerut</h4>
                        <p>
                            (FORMERLY, MEERUT UNIVERSITY) | <span>NAAC A++ ACCREDITED</span>
                        </p>
                    </div>
                </div>
                <div className="welcome-sub-slider-main">
                    <div id="carouselExampleIndicators" 
                        class="carousel slide" 
                        data-bs-ride="carousel"
                        data-bs-interval="3000"
                        data-bs-wrap="true">
                        {/* <div className="carousel-indicators">
                            <button
                                type="button"
                                data-bs-target="#carouselExampleIndicators"
                                data-bs-slide-to={0}
                                className="active"
                                aria-current="true"
                                aria-label="Slide 1"
                            />
                            <button
                                type="button"
                                data-bs-target="#carouselExampleIndicators"
                                data-bs-slide-to={1}
                                aria-label="Slide 2"
                            />
                            <button
                                type="button"
                                data-bs-target="#carouselExampleIndicators"
                                data-bs-slide-to={2}
                                aria-label="Slide 3"
                            />
                            <button
                                type="button"
                                data-bs-target="#carouselExampleIndicators"
                                data-bs-slide-to={3}
                                aria-label="Slide 4"
                            />
                            <button
                                type="button"
                                data-bs-target="#carouselExampleIndicators"
                                data-bs-slide-to={4}
                                aria-label="Slide 5"
                            />
                            <button
                                type="button"
                                data-bs-target="#carouselExampleIndicators"
                                data-bs-slide-to={5}
                                aria-label="Slide 6"
                            />
                            <button
                                type="button"
                                data-bs-target="#carouselExampleIndicators"
                                data-bs-slide-to={6}
                                aria-label="Slide 7"
                            />
                        </div> */}
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <div className="carousel-item-inner">
                                    <div className="item-image">
                                        <img src="/assets/images/ccsu-logo-half.svg" alt="" />
                                    </div>
                                    <div>
                                        <h6 className="text-uppercase">CCSU Rankings</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="carousel-item-inner">
                                    <div className="item-image">
                                        <img
                                            src="/assets/images/circle-category/naac-logo.png"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>NAAC</h6>
                                        <p>'A++'-Grade</p>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="carousel-item-inner">
                                    <div className="item-image">
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/09/mdra_logo.webp"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>#15</h6>
                                        <p>MDRA Ranking in India 2026</p>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="carousel-item-inner">
                                    <div className="item-image">
                                        <img
                                            src="https://cdn.ccsuniversity.ac.in/public/webp/2026/09/mdra_logo.webp"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>#2</h6>
                                        <p>MDRA Ranking in UP State Universities 2026</p>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="carousel-item-inner">
                                    <div className="item-image">
                                        <img
                                            src="https://www.vit.edu/wp-content/uploads/2025/07/Frame-1000010331.webp"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>#41</h6>
                                        <p>NIRF Ranking 2025</p>
                                        <p>State Public University</p>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="carousel-item-inner">
                                    <div className="item-image">
                                        <img
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAwFBMVEVHcEwHmtkXY7AEmNcBod4HjM0Hj9AgT6MaXKsQecAnQZsGjM4MesEKhMgCoNwpPpobXqwpPJgJhMgDecAFldQuMJELltYpPJgIjs8lRZ0CoNwcVqccVqcHhskJicsGndsDdb0Oa7cqO5gZW6opP5oJjc4aXq0XZLEpO5csNpUZV6ctM5MFnNoAoN4lSZ8AesAAdr0nQpsAot8Ll9YFf8QaV6YLlNQGcbkJg8cQa7YpO5gJh8kZZ7IJj9AaYa4tM5PM+HH+AAAALHRSTlMAatIoDP6N/v4EH31HGdEOOpxXvjkz8Uipv6WS4OnP5ueh5KTXnLp472Jm+UkOw7QAAAEGSURBVCiRjdHZUoMwFIBhktQIJGwFaVm7163VKkrdKu//VsKhmGW88LtgMvwDOQHD+B/PvmrZ3l9pEqzvm6ZZBre23uzg5mOQTNRmJU+SpVqDB8Va3ti/7OXJeZFJcfUK7tr3Z7DKHbEjNoHfTbY1zRxnYmIPf4NtV/nq2lfmwV89rN0Hi/cBXnBLi/wozMOxVulBOB5CrbJH2dxRKw+LFyHUNrbGm/JtUOj7GlbEys8zqpSI8fZK2EVvKgphZXGadlOM6AmISOO6ruoadWtUA/FaPqvAhjgohlUsDZTuflVwdaWDEnenQsqs7l7G1DOSdP88cJH+Y0YRdbsySxHRvw50ID31A3MAN332Z6KOAAAAAElFTkSuQmCC"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <p>Highest Number of Enrollments/Courses in Swayam Portal among State Universities in U.P.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="carousel-item-inner">
                                    <div className="item-image">
                                        <img
                                            src="https://www.vit.edu/wp-content/uploads/2025/07/Frame-1000010331.webp"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>#151-200</h6>
                                        <p>NIRF Ranking 2025</p>
                                        <p>Rank Band in University Category</p>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="carousel-item-inner">
                                    <div className="item-image">
                                        <img
                                            src="/assets/images/circle-category/ranking1.png"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>#694</h6>
                                        <p>in QS Asia University Rankings | 2027</p>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="carousel-item-inner">
                                    <div className="item-image">
                                        <img
                                            src="/assets/images/circle-category/ranking1.png"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>#201</h6>
                                        <p>in QS Asia University Rankings 2027: Southern Asia</p>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="carousel-item-inner">
                                    <div className="item-image">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpeg/2024/07/webometrics.jpeg"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>#139</h6>
                                        <p>Rankings web of Universities: Meerut Country Rank</p>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="carousel-item-inner">
                                    <div className="item-image">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpeg/2024/07/webometrics.jpeg"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>#908</h6>
                                        <p>Rankings web of Universities: Continental Rank</p>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="carousel-item-inner">
                                    <div className="item-image">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpeg/2024/07/webometrics.jpeg"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>#2876</h6>
                                        <p>Rankings web of Universities: World Rank</p>
                                    </div>
                                </div>
                            </div>
                            <button
                                className="carousel-control-prev"
                                type="button"
                                data-bs-target="#carouselExampleIndicators"
                                data-bs-slide="prev"
                            >
                                <span
                                    className="carousel-control-prev-icon"
                                    aria-hidden="true"
                                />
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button
                                className="carousel-control-next"
                                type="button"
                                data-bs-target="#carouselExampleIndicators"
                                data-bs-slide="next"
                            >
                                <span
                                    className="carousel-control-next-icon"
                                    aria-hidden="true"
                                />
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="searchs d-flex">
                    <div id="search">
                        <form id="searchinput" onSubmit={(e) => e.preventDefault()}>
                            <input
                                type="search"
                                autoComplete="off"
                                id="searchInput"
                                placeholder="Search here"
                                value={query}
                                onChange={handleInputChange}
                            />
                            <button type="submit">
                                <i className="fa fa-search" aria-hidden="true" />
                            </button>
                        </form>

                        {/* Conditionally render the search result container */}
                        {(results.length > 0 || query !== '') && (
                            <div className="search-result-div">
                                <div id="searchResultsContainer" className="dropdown-content" style={{ position: 'relative' }}>
                                    <ul id="searchResultsList">
                                        {results.map((title) => (
                                            <li key={title}>
                                                <a href={pages[title]}>
                                                    <i className="fas fa-external-link-alt mr-1"></i>
                                                    {title}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                    {noResults && (
                                        <p id="noResults">
                                            No match found for '{query}'.
                                        </p>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="nav-btn">
                        <Link to={"/admission"} className="first-button">
                            ADMISSION 2026-2027
                        </Link>
                        <Link
                            to="https://result.ccsuniversity.ac.in/"
                            className="second-button"
                            target="_blank"
                        >
                            <i className="fas fa-file" style={{ paddingRight: 5 }} />
                            RESULTS
                        </Link>
                    </div>
                </div>
            </section>
            {/* mobile view header */}
            {/* end mobile view header */}
            <nav className="navbar navbar-expand-lg navbar-dark" id="navbar-mainn">
                <div
                    className="container-fluid justify-content-end"
                    style={{ marginLeft: 10 }}
                >
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNavDropdown"
                        aria-controls="navbarNavDropdown"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        style={{ border: "1px solid #fff" }}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>


                    <div className="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul
                            className="navbar-nav flex-column flex-lg-row flex-wrap"
                            style={{ justifyContent: "center" }}
                        >
                            <li className="nav-item dropdown dropdown-hover">
                                <Link to={"/"} className="nav-link">
                                    <i
                                        className="fa-solid fa-house"
                                        style={{ color: "#f4c751" }}
                                    />
                                </Link>
                            </li>
                            <li className="nav-item dropdown dropdown-hover">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to={"#"}
                                    id="navbarDropdownMenuLink"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    ABOUT US
                                    <i className="fa-solid fa-caret-down" />
                                </Link>
                                <ul
                                    className="dropdown-menu"
                                    aria-labelledby="navbarDropdownMenuLink"
                                >
                                    <li>
                                        <Link className="dropdown-item" to={"/history"}>
                                            History
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/vision-mission"}>
                                            Vision &amp; Mission
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/chaudhary-charan-singh"}>
                                            Hon'ble Chaudhary Charan Singh Ji
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/chancellor"}>
                                            H.E. Chancellor
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/vice-chancellor"}>
                                            Vice Chancellor's Message
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/governance"}>
                                            Government framework
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item dropdown dropdown-hover">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to={"#"}
                                    id="navbarDropdownMenuLink"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    ADMINISTRATION
                                    <i className="fa-solid fa-caret-down" />
                                </Link>
                                <ul
                                    className="dropdown-menu"
                                    aria-labelledby="navbarDropdownMenuLink"
                                >
                                    <li>
                                        <Link className="dropdown-item" to={"/administration"}>
                                            Administrative office
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/deans-faculty"}>
                                            Deans
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/wardens"}>
                                            Wardens
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            className="dropdown-item"
                                            to={"/deans-students-welfare"}
                                        >
                                            Deans Students Welfare
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/proctors"}>
                                            Proctors
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/officer-incharge"}>
                                            Officer/Incharge
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            className="dropdown-item"
                                            to={"/cell-and-coordinators"}
                                        >
                                            Cell and Coordinators
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            className="dropdown-item"
                                            to={"/engineering-section"}
                                        >
                                            Engineering Section
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/dispensary"}>
                                            Dispensary
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item dropdown dropdown-hover position-static">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to={"#"}
                                    id="navbarDropdown"
                                    role="button"
                                    data-mdb-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Institutes/Departments/Constituent colleges
                                    <i className="fa-solid fa-caret-down" />
                                </Link>
                                {/* Dropdown menu */}
                                <div
                                    className="dropdown-menu mt-0"
                                    aria-labelledby="navbarDropdown"
                                    style={{
                                        borderTopLeftRadius: 0,
                                        borderTopRightRadius: 0,
                                        paddingLeft: 20,
                                        paddingRight: 20,
                                    }}
                                >
                                    {/* <div className="container-fluid"> */}
                                    <div className="row my-4">
                                        <div className="col-md-6 mb-3 mb-lg-0">
                                            <div className="pb-3">
                                                <h4 style={{ textAlign: "center" }}>Institutes</h4>
                                            </div>
                                            <div>
                                                <div>
                                                    <Link
                                                        className="dropdown-item"
                                                        to={"https://csop.ccsuniversity.ac.in/"}
                                                        target="_blank"
                                                    >
                                                        Charak School of Pharmacy
                                                    </Link>
                                                </div>
                                                <div>
                                                    <Link
                                                        className="dropdown-item"
                                                        to={"https://scriet.ccsuniversity.ac.in"}
                                                        target="_blank"
                                                        style={{ textWrap: "wrap" }}
                                                    >
                                                        Sir Chhotu Ram Institute of Engineering Technology
                                                    </Link>
                                                </div>
                                                <div>
                                                    <Link
                                                        className="dropdown-item"
                                                        to={"/faculty/Art/department/Institute_Fine_Arts"}
                                                        style={{ textWrap: "wrap" }}
                                                    >
                                                        Institute of Fine Arts
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3 mb-lg-0">
                                            {/* <div className="pb-3">
                                                <h4 style={{ textAlign: "center" }}>
                                                    Constituent Colleges
                                                </h4>
                                            </div> */}
                                            <div>
                                                {/* <div>
                                                    <Link
                                                        className="dropdown-item"
                                                        to={"https://www.llrmmedicalcollege.edu.in/"}
                                                        target="_blank"
                                                        style={{ textWrap: "wrap" }}
                                                    >
                                                        Lala Lajpat Rai Memorial Medical College
                                                    </Link>
                                                </div> */}
                                                {/* <div>
                                                    <Link
                                                        className="dropdown-item"
                                                        to={"https://gccjr.org/"}
                                                        target="_blank "
                                                        style={{ textWrap: "wrap" }}
                                                    >
                                                        Shanti Devi Government Degree College Jewar
                                                        (Rabupura)
                                                    </Link>
                                                </div> */}
                                                {/* <div>
                                                    <Link
                                                        className="dropdown-item"
                                                        to={"https://gcph.in/web/"}
                                                        target="_blank"
                                                        style={{ textWrap: "wrap" }}
                                                    >
                                                        Government College, Pandwan, Hastinapur (Meerut)
                                                    </Link>
                                                </div> */}
                                                {/* <div>
                                                    <Link
                                                        className="dropdown-item"
                                                        to={"https://gcsh.in/"}
                                                        target="_blank "
                                                        style={{ textWrap: "wrap" }}
                                                    >
                                                        Government College, Salarpur, Hapur
                                                    </Link>
                                                </div> */}
                                                {/* <div>
                                                    <Link
                                                        className="dropdown-item"
                                                        to={"https://gcpb.in/web/"}
                                                        target="_blank "
                                                        style={{ textWrap: "wrap" }}
                                                    >
                                                        Government College Pabla
                                                    </Link>
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-3 mb-lg-0">
                                            <div className="pb-3">
                                                <h4 style={{ textAlign: "center" }}>Departments</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="list-group list-group-flush">
                                                        {/* Loader or error */}
                                                        {loader && <div className="loader">Loading...</div>}
                                                        {error && <div className="error">{error}</div>}

                                                        {departments.length > 0 ? (
                                                            departments.slice(0, 13).map((department) => {
                                                                // Determine the link for the department
                                                                const link = department.website
                                                                    ? department.website
                                                                    : `/faculty/${department.faculty_url_id}/department/${department.url_id}`;

                                                                return (
                                                                    <Link
                                                                        to={link}
                                                                        key={department.name}
                                                                        className="list-group-item list-group-item-action"
                                                                    >
                                                                        {department.name}
                                                                    </Link>
                                                                );
                                                            })
                                                        ) : (
                                                            <div>No departments available.</div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="list-group list-group-flush">
                                                        {departments.length > 0 ? (
                                                            departments.slice(13, 26).map((department) => {
                                                                const link = department.website
                                                                    ? department.website
                                                                    : `/faculty/${department.faculty_url_id}/department/${department.url_id}`;

                                                                return (
                                                                    <Link
                                                                        to={link}
                                                                        key={department.name}
                                                                        className="list-group-item list-group-item-action"
                                                                    >
                                                                        {department.name}
                                                                    </Link>
                                                                );
                                                            })
                                                        ) : (
                                                            <div>No departments available.</div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="list-group list-group-flush">
                                                        {departments.length > 0 ? (
                                                            departments.slice(26, 41).map((department) => {
                                                                const link = department.website
                                                                    ? department.website
                                                                    : `/faculty/${department.faculty_url_id}/department/${department.url_id}`;

                                                                return (
                                                                    <Link
                                                                        to={link}
                                                                        key={department.name}
                                                                        className="list-group-item list-group-item-action"
                                                                    >
                                                                        {department.name}
                                                                    </Link>
                                                                );
                                                            })
                                                        ) : (
                                                            <div>No departments available.</div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </li>
                            <li className="nav-item dropdown dropdown-hover position-static">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to={"#"}
                                    id="navbarDropdown"
                                    role="button"
                                    data-mdb-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    ACADEMIC
                                    <i className="fa-solid fa-caret-down" />
                                </Link>
                                <div
                                    className="dropdown-menu mt-0"
                                    aria-labelledby="navbarDropdown"
                                    style={{
                                        borderTopLeftRadius: 0,
                                        borderTopRightRadius: 0,
                                        paddingLeft: 20,
                                        paddingRight: 20,
                                    }}
                                >
                                    <div className="row my-4">
                                        <div className="col-md-6 mb-3 mb-lg-0">
                                            <div className="pb-3">
                                                <h4 style={{ textAlign: "center" }}>Faculties</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="list-group list-group-flush">
                                                        <Link
                                                            to={"/faculty/"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            All
                                                        </Link>
                                                        <Link
                                                            to={"/faculty/Agriculture"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Agriculture
                                                        </Link>
                                                        <Link
                                                            to={"/faculty/Art"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Art
                                                        </Link>
                                                        <Link
                                                            to={"/faculty/Commerce_and_Management"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Commerce &amp; Management
                                                        </Link>
                                                        <Link
                                                            to={"/faculty/Education"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Education
                                                        </Link>
                                                        <Link
                                                            to={"/faculty/Engineering_and_Technology"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Engineering &amp; Technology
                                                        </Link>
                                                        <Link
                                                            to={"/faculty/Law"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Law
                                                        </Link>
                                                        <Link
                                                            to={"/faculty/Pharmacy"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Pharmacy
                                                        </Link>
                                                        <Link
                                                            to={"/faculty/Science"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Science
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3 mb-lg-0">
                                            <div className="pb-3">
                                                <h4 style={{ textAlign: "center" }}>Programmes</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="list-group list-group-flush">
                                                        <Link
                                                            to={"/prog-offered-courses"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            All Programmes
                                                        </Link>
                                                        <Link
                                                            to={"/regular-courses"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Regular Courses
                                                        </Link>
                                                        <Link
                                                            to={"/self-finance-courses"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Self-Financial Courses
                                                        </Link>
                                                        <Link
                                                            to={"/skill-development-syllabus"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Skill Development Courses
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="pb-3">
                                                <h4 style={{ textAlign: "center" }}>Syllabus</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="list-group list-group-flush">
                                                        <Link
                                                            to={"/campus-syllabus"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Campus Syllabus
                                                        </Link>
                                                        <Link
                                                            to={"/college-syllabus"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            College Syllabus
                                                        </Link>
                                                        <Link
                                                            to={"/nep-syllabus"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            NEP-2020 Syllabus
                                                        </Link>
                                                        <Link
                                                            to={"/skill-development-syllabus"}
                                                            className="list-group-item list-group-item-action"
                                                        >
                                                            Skill Development Syllabus
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="nav-item dropdown dropdown-hover">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to={"#"}
                                    id="navbarDropdownMenuLink"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    Infrastructure
                                    <i className="fa-solid fa-caret-down" />
                                </Link>
                                <ul
                                    className="dropdown-menu"
                                    aria-labelledby="navbarDropdownMenuLink"
                                >
                                    <li>
                                        <Link className="dropdown-item" to={"/facilities"}>
                                            Facilities
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/library"}>
                                            Library
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item dropdown dropdown-hover">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to={"#"}
                                    id="navbarDropdownMenuLink"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    LIBRARY
                                    <i className="fa-solid fa-caret-down" />
                                </Link>
                                <ul
                                    className="dropdown-menu"
                                    aria-labelledby="navbarDropdownMenuLink"
                                >
                                    <div className="row">
                                        <div className="col-md-12">
                                            <li>
                                                <Link className="dropdown-item" to={"/library"}>
                                                    Central Library
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://digital-lib.ccsuniversity.ac.in/"}
                                                    target="_blank"
                                                >
                                                    Digital Library
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://bridge-library.ccsuniversity.ac.in/"}
                                                    target="_blank"
                                                >
                                                    Bridge Library
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"http://ir.ccsuniversity.ac.in/jspui/"}
                                                    target="_blank"
                                                >
                                                    Institutional Repository
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://heecontent.upsdc.gov.in/Home.aspx"}
                                                    target="_blank"
                                                >
                                                    UPHEDL
                                                </Link>
                                            </li>
                                        </div>
                                    </div>
                                </ul>
                            </li>
                            <li className="nav-item dropdown dropdown-hover">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to={"#"}
                                    id="navbarDropdownMenuLink"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    IQAC
                                    <i className="fa-solid fa-caret-down" />
                                </Link>
                                <ul
                                    className="dropdown-menu"
                                    aria-labelledby="navbarDropdownMenuLink"
                                >
                                    <div className="new-menu-try">
                                        <div className="col-lg-5">
                                            <li>
                                                <Link className="dropdown-item" to={"/iqac"}>
                                                    IQAC
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/iqac-aqar-report"}
                                                >
                                                    AQAR Reports
                                                </Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" to={"/iqac-meet"}>
                                                    Minutes of IQAC Meetings
                                                </Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" to={"/iqac-practices"}>
                                                    Best Practices
                                                </Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" to={"/iqac-letter"}>
                                                    IQAC Committee Letter
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/iqac-notifications"}
                                                >
                                                    Notifications
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/distinctiveness"}
                                                >
                                                    Institutional Distinctiveness
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/industry-consultancy-cell"}
                                                >
                                                    Industry Consultancy Cell
                                                </Link>
                                            </li>
                                        </div>
                                        <div className="col-lg-6">
                                            <li>
                                                <Link className="dropdown-item" to={"/iqac-facilities"}>
                                                    Facilities
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/proceeding-ac-bos"}
                                                >
                                                    Proceeding AC/BOS
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/student-projects-reports"}
                                                >
                                                    Student Projects/ Field Reports
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/academic-calendar"}
                                                >
                                                    Academic Calendar
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/audited-statement"}
                                                >
                                                    Audited Statement of Income Expenditure
                                                </Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" to={"/iqac-feedback"}>
                                                    Feedback
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/iqac-activities"}
                                                >
                                                    Activities
                                                </Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" to={"/iqac-contact"}>
                                                    Contact
                                                </Link>
                                            </li>
                                        </div>
                                    </div>
                                </ul>
                            </li>
                            <li className="nav-item dropdown dropdown-hover">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to={"#"}
                                    id="navbarDropdownMenuLink"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    Admission
                                    <i className="fa-solid fa-caret-down" />
                                </Link>
                                <ul
                                    className="dropdown-menu"
                                    aria-labelledby="navbarDropdownMenuLink"
                                >
                                    <div className="row">
                                        <div className="col-md-12">
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/admission-brochure"}
                                                >
                                                    Admission Brochure
                                                </Link>
                                            </li>
                                        </div>
                                    </div>
                                </ul>
                            </li>
                            <li className="nav-item dropdown dropdown-hover">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to={"#"}
                                    id="navbarDropdownMenuLink"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    Examination
                                    <i className="fa-solid fa-caret-down" />
                                </Link>
                                <ul
                                    className="dropdown-menu"
                                    aria-labelledby="navbarDropdownMenuLink"
                                >
                                    <li>
                                        <Link className="dropdown-item" to={"/exam-rules"}>
                                            Exam Rules (समस्त परीक्षा नियम)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/exam-related-info"}>
                                            Exam Related Information (परीक्षा से सम्बन्धित सूचनाएं)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/exam-schedule"}>
                                            Exam Schedule/Revised Exam Schedule
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/exam-form-and-admit-card"}>
                                            Examination Forms (परीक्षा फार्म का link)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={"/code-books"}>
                                            Code Books
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item dropdown dropdown-hover">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to={"#"}
                                    id="navbarDropdownMenuLink"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    STUDENTS CORNER
                                    <i className="fa-solid fa-caret-down" />
                                </Link>
                                <ul
                                    className="dropdown-menu"
                                    aria-labelledby="navbarDropdownMenuLink"
                                    style={{ left: "-360px" }}
                                >
                                    <div className="new-menu-try">
                                        <div className="col-md-6">
                                            <li>
                                                <Link className="dropdown-item" to={"/syllabus"}>
                                                    Syllabus
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://result.ccsuniversity.ac.in/"}
                                                    target="_blank"
                                                >
                                                    Result
                                                </Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" to={"/anti-ragging"}>
                                                    Anti ragging
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/conduct-discipline"}
                                                >
                                                    Conduct &amp; Discipline
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"http://ccsuniversityhostel.com/"}
                                                    target="blank"
                                                >
                                                    Hostel Registration
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://exams.ccsuforms.in/FeePayPanel/"}
                                                    target="blank"
                                                >
                                                    Online Fees Payment for Campus Courses
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://forms.ccsuforms.in/Campus_Fee/"}
                                                    target="blank"
                                                >
                                                    Campus Fee Payment
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://forms.ccsuforms.in/onlinecertificate/"}
                                                    target="blank"
                                                >
                                                    Online Provisional &amp; Migration Certificate
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/student-council"}
                                                >
                                                    Student Council
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://cdn.ccsuniversity.ac.in/public/pdf/2026/01/DocScanner%2017-Jan-2026%2003-56%20PM.pdf"}
                                                    target="_blank"
                                                >
                                                    Fee Refund Policy
                                                </Link>
                                            </li>
                                        </div>
                                        <div className="col-md-6">
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/All-PDF/Students-Handbook.pdf"}
                                                    target="blank"
                                                >
                                                    Student Handbook
                                                </Link>
                                            </li>
                                            {/* <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://exams.ccsuforms.in/FeePayPanel/misslenious_fee.php"}
                                                    target="_blank"
                                                >
                                                    Viva fees
                                                </Link>
                                            </li> */}
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://docs.google.com/forms/d/e/1FAIpQLSerV466RZUBe0Jlaeds0XVq9sy36gq6_yECroPFieqOcYxMRQ/viewform?usp=sf_link"}
                                                    target="blank"
                                                >
                                                    Student Satisfaction Survey
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://forms.gle/Y7mKi1oZqC53mL4U6"}
                                                    target="blank"
                                                >
                                                    Student Feedback form
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/grievance"}
                                                    
                                                >
                                                    Student Grievance Form
                                                </Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" to={"/omr"}>
                                                    OMR Keys, Sheet &amp; Response
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://ccsuwebonline.in/"}
                                                    target="blank"
                                                >
                                                    Student Help Desk{" "}
                                                    <span style={{ color: "#db4e4e" }} id="new-blink">
                                                        'New'
                                                    </span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://ccsuanswerview.com/"}
                                                    target="blank"
                                                >
                                                    Answer Book Viewing &amp; Challenge Evaluation
                                                </Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" to={"/women-cell"}>
                                                    Women Cell
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/left-out-practical"}
                                                >
                                                    Apply for left out practical/viva
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/verification"}
                                                >
                                                    Document Verification
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"https://ncc.ccsuniversity.ac.in/"}
                                                    target="_blank"
                                                >
                                                    NCC
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    className="dropdown-item"
                                                    to={"/nss"}
                                                >
                                                    NSS
                                                </Link>
                                            </li>
                                        </div>
                                    </div>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to={"/career"}>
                                    {" "}
                                    Jobs Opening{" "}
                                </Link>
                            </li>
                            {/* <li className="nav-item">
                                <Link className="nav-link" to={"https://staffdatacollection.ccsuniversity.ac.in/"}>
                                    {" "}
                                    Staff Data Collection{" "}
                                </Link>
                            </li> */}
                            {/* <li className="nav-item">
                                <Link className="nav-link" to={"https://internetuserdata.ccsuniversity.ac.in/"}>
                                    {" "}
                                    Internet User Form{" "}
                                </Link>
                            </li> */}
                            <li className="nav-item dropdown dropdown-hover">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    id="swayamDropdown"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    Swayam@ccsu
                                    <i className="fa-solid fa-caret-down" />
                                </Link>

                                <ul className="dropdown-menu" aria-labelledby="swayamDropdown">
                                    <li>
                                    <Link
                                        className="dropdown-item"
                                        to="https://swayam.gov.in/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        SWAYAM Portal
                                    </Link>
                                    </li>
                                    <li>
                                    <Link
                                        className="dropdown-item"
                                        to="/proceedings"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Proceedings
                                    </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to={"https://ccsuniversity.samarth.edu.in/"}>
                                    {" "}
                                    Samarth Student Login{" "}
                                </Link>
                            </li>

                            <li className="nav-item dropdown dropdown-hover">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    id="aidropdown"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    AI for ALL
                                    <i className="fa-solid fa-caret-down" />
                                </Link>

                                <ul className="dropdown-menu" aria-labelledby="swayamDropdown">
                                    <li>
                                        <Link
                                        className="dropdown-item"
                                        to="https://cdn.ccsuniversity.ac.in/public/pdf/2026/10/Scanned%20Document%20(1).pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                            AI for All Course for First-Semester Students (2026–27)
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                        className="dropdown-item"
                                        to="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/Notice%20-%20Compliance%20for%20registration%20in%20AI%20for%20All%20course.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                            Notice - Compliance for registration in AI for All course
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                        className="dropdown-item"
                                        to="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/Notice%20for%20AI%20for%20All%20course%20exam%20schedule.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                            Notice for AI for All course exam schedule
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                        className="dropdown-item"
                                        to="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/Office%20Order%20for%20AI%20Course.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                            Office Order for AI Course
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                        className="dropdown-item"
                                        to="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/RO.%20504%20Date%2002.04.2026%20(AI%20Nodal%20Coordinator%20-%20Sachin%20Kumar)-1.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                            AI Nodal Coordinator - Sachin Kumar
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                        className="dropdown-item"
                                        to="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/RO.%20505%20Date%2002.04.2026%20(AI%20For%20All%20Course%20for%20Campus%20&%20Affiliated%20Colleges)%20(1).pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                            AI For All Course for Campus & Affiliated Colleges
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to={"https://cdn.ccsuniversity.ac.in/public/pdf/2026/09/RLB%20Scooty%20Yojana%20Notice.pdf"} target="_blank">
                                    {" "}
                                    स्कूटी संबंधी डाटा इस ईमेल पर भेजे{" "}
                                </Link>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Header;
